import { apiUrl } from './global';

const authProvider = {
    login: ({ username, password }) => {
        return fetch(apiUrl + '/LJXAdmin/LJXAdminAuth/Login', {
            method: 'POST',
            headers: { 'content-type': 'application/x-www-form-urlencoded' },
            body: `username=${encodeURIComponent(username)}&password=${encodeURIComponent(password)}`
        })
            .then(response => {
                if (response.status === 401) {
                    throw new Error('账号或密码不正确');
                }
                if (response.status === 500) {
                    throw new Error('服务器错误，请稍后重试');
                }
                if (response.status === 404) {
                    throw new Error('接口不存在');
                }
                if (!response.ok) {
                    throw new Error('网络错误，请检查网络连接');
                }
                return response.json();
            })
            .then((result) => {
                if (result.Code === 1) {
                    localStorage.setItem('token', result.Result.Token);
                    return result;
                } else {
                    throw new Error(result.Message || '登录失败');
                }
            });
    },

    logout: () => {
        return new Promise((resolve, reject) => {
            localStorage.removeItem('token');
            resolve();
        });
    },

    checkAuth: () => {
        const token = localStorage.getItem('token');
        if (!token) {
            return Promise.reject();
        }

        try {
            const parts = token.split('.');
            if (parts.length !== 3) {
                localStorage.removeItem('token');
                return Promise.reject();
            }

            const payload = JSON.parse(atob(parts[1]));
            const exp = payload.exp * 1000;
            
            if (Date.now() >= exp) {
                localStorage.removeItem('token');
                return Promise.reject();
            }

            return Promise.resolve();
        } catch (error) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
    },

    checkError: (error) => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            return Promise.reject();
        }
        return Promise.resolve();
    },

    getPermissions: () => {
        const token = localStorage.getItem('token');
        if (!token) {
            return Promise.resolve([]);
        }

        try {
            const parts = token.split('.');
            if (parts.length !== 3) {
                return Promise.resolve([]);
            }

            const decodeToken = JSON.parse(decodeURIComponent(atob(parts[1].replace('-', '+').replace('_', '/')).split('').map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`).join('')));
            const role = decodeToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
            return Promise.resolve(role || []);
        } catch (error) {
            return Promise.resolve([]);
        }
    },

    getIdentity: () => {
        const token = localStorage.getItem('token');
        if (!token) {
            return Promise.reject();
        }

        try {
            const parts = token.split('.');
            if (parts.length !== 3) {
                return Promise.reject();
            }

            const decodeToken = JSON.parse(decodeURIComponent(atob(parts[1].replace('-', '+').replace('_', '/')).split('').map(c => `%${('00' + c.charCodeAt(0).toString(16)).slice(-2)}`).join('')));
            const userdata = JSON.parse(decodeToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata'] || '{}');
            const id = decodeToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/sid'] || '1';
            const fullName = userdata.NickName || userdata.Account || '管理员';
            const avatar = userdata.Avatar || '';
            
            return Promise.resolve({ id, fullName, avatar });
        } catch (error) {
            return Promise.reject(error);
        }
    }
};

export default authProvider;